/* unplugin-vue-components disabled */import script from "./StudyMaterialDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./StudyMaterialDetail.vue?vue&type=script&lang=ts&setup=true"

import "./StudyMaterialDetail.vue?vue&type=style&index=0&id=e9954666&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9954666"]])

export default __exports__